import React from 'react';

const TermsConditions = () => (
  <div>
    <div className="page-header">
      <div className="container"><h1>Terms &amp; Conditions</h1><p>Please read before using our platform</p></div>
    </div>
    <div className="policy-content">
      <h2>Acceptance of Terms</h2>
      <p>By accessing or using the One Clutch website, you agree to be bound by these Terms &amp; Conditions. You must be at least 18 years old, or using the site under the supervision of a parent or guardian, to place an order.</p>

      <h2>Product Information</h2>
      <p>We make every effort to display accurate product descriptions, images, brand names, and vehicle compatibility details. However, slight variations in packaging or specification from the manufacturer may occur. Please verify fitment details before ordering.</p>

      <h2>Pricing &amp; Payment</h2>
      <p>All prices are listed in INR and are subject to change without notice. Payment is accepted via Razorpay (cards, UPI, netbanking) or Cash on Delivery, where available.</p>

      <h2>Order Acceptance</h2>
      <p>We reserve the right to refuse or cancel any order due to stock unavailability, pricing errors, or suspected fraudulent activity. In such cases, a full refund will be issued if payment was already made.</p>

      <h2>Limitation of Liability</h2>
      <p>One Clutch is not liable for indirect damages arising from the use of purchased parts, including improper installation. We recommend professional fitment for safety-critical components such as brakes and suspension.</p>

      <h2>Governing Law</h2>
      <p>These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in our registered business location.</p>
    </div>
  </div>
);

export default TermsConditions;
